import Vue from 'vue';
import Vuelidate from "vuelidate";
import App from './App.vue';
import vuetify from './plugins/vuetify';
import ajax from "./plugins/ajax";


Vue.config.productionTip = false;
Vue.use(ajax);
Vue.use(Vuelidate);

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app');
